export default __webpack_public_path__ + "static/media/Size3D.e798b09f.png";